var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRankicon = function SvgRankicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.348 1.694a.5.5 0 0 1 .612.353l1.147 4.28a.5.5 0 0 1-.353.613l-.483.13a.5.5 0 0 1-.613-.354l-.614-2.29-3.633 6.293a.5.5 0 0 1-.683.183L4.861 8.67 1.9 13.8a.5.5 0 0 1-.683.182l-.433-.25a.5.5 0 0 1-.183-.683l3.46-5.995a.5.5 0 0 1 .684-.183l3.867 2.233 3.133-5.427-2.29.613a.5.5 0 0 1-.612-.353l-.13-.483a.5.5 0 0 1 .354-.612l4.28-1.147Z",
    clipRule: "evenodd"
  })));
};
export default SvgRankicon;